var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6 10.7273C19.6 10.0182 19.5364 9.33643 19.4182 8.68188H10V12.5501H15.3818C15.15 13.8001 14.4455 14.8592 13.3864 15.5682V18.0773H16.6182C18.5091 16.3364 19.6 13.7728 19.6 10.7273Z",
    fill: "#1976D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99984 20.5001C12.6998 20.5001 14.9635 19.6047 16.618 18.0774L13.3862 15.5683C12.4907 16.1683 11.3453 16.5229 9.99984 16.5229C7.39529 16.5229 5.19075 14.7638 4.40439 12.4001H1.06348V14.9911C2.70893 18.2592 6.09075 20.5001 9.99984 20.5001Z",
    fill: "#4CAF50"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.40455 12.3999C4.20455 11.7999 4.09091 11.159 4.09091 10.4999C4.09091 9.84085 4.20455 9.19994 4.40455 8.59994V6.00903H1.06364C0.386364 7.35903 0 8.88631 0 10.4999C0 12.1136 0.386364 13.6409 1.06364 14.9909L4.40455 12.3999Z",
    fill: "#FFC107"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99984 4.47727C11.468 4.47727 12.7862 4.98182 13.8226 5.97273L16.6907 3.10455C14.9589 1.49091 12.6953 0.5 9.99984 0.5C6.09075 0.5 2.70893 2.74091 1.06348 6.00909L4.40439 8.6C5.19075 6.23636 7.39529 4.47727 9.99984 4.47727Z",
    fill: "#FF3D00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.5ab75f84.svg";
export { ForwardRef as ReactComponent };